import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },

  // Public routes
  {
    path: 'authentication',
    loadComponent: () => import('../pages/authentication/authentication').then(m => m.AuthenticationPage),
  },
  {
    path: 'error',
    loadComponent: () => import('../pages/error/error').then(m => m.ErrorPage),
  },
  {
    path: 'not-allowed',
    loadComponent: () => import('../pages/not-allowed/not-allowed').then(m => m.NotAllowedPage),
  },

  // Protected routes
  {
    path: 'index',
    loadComponent: () => import('../pages/index/index').then(m => m.Index),
    canActivate: [authGuard],
  },
  {
    path: 'vacations-absences',
    loadChildren: () => import('../pages/vacations-absences/vacations-absences.routes').then(m => m.vacationsAbsencesRoutes),
    canActivate: [authGuard],
  },
  {
    path: 'food-benefit',
    loadChildren: () => import('../pages/food-benefit/food-benefit.routes').then(m => m.foodBenefitRoutes),
    canActivate: [authGuard],
  },
  {
    path: 'loans',
    loadChildren: () => import('../pages/loans/loans.routes').then(m => m.loansRoutes),
    canActivate: [authGuard],
  },
  {
    path: 'solidarity',
    loadChildren: () => import('../pages/solidarity/solidarity.routes').then(m => m.solidarityRoutes),
    canActivate: [authGuard],
  },
  {
    path: 'social-security',
    loadComponent: () => import('../pages/social-security/social-security').then(m => m.SocialSecurityPage),
    canActivate: [authGuard],
  },

  { path: '**', redirectTo: 'index' },
];
